import { render, staticRenderFns } from "./LanguageManagerModal.vue?vue&type=template&id=40998b32"
import script from "./LanguageManagerModal.vue?vue&type=script&lang=js"
export * from "./LanguageManagerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports